import {
  Datagrid,
  DateField,
  FunctionField,
  TextField,
  usePermissions,
  useTranslate,
} from 'react-admin'

const EmrDatagrid = ({ rowClick = 'edit' }) => {
  const translate = useTranslate()
  const { permissions } = usePermissions()

  // Disable row click for siteadmin (read-only role)
  const effectiveRowClick = permissions?.role === 'siteadmin' ? 'show' : rowClick

  return (
    <Datagrid rowClick={effectiveRowClick} bulkActionButtons={false}>
      <TextField source="id" />
      <FunctionField
        label={translate('resources.emrs.fields.pet')}
        render={(record) => record.pet?.name ?? translate('pos.common.empty_data')}
      />
      <FunctionField
        label={translate('resources.emrs.fields.vet')}
        render={(record) => record.vet?.name ?? translate('pos.common.empty_data')}
      />
      <TextField source="notes" />
      <DateField source="timestamp" label={translate('resources.emrs.fields.date')} />
      <DateField source="createdAt" label={translate('resources.emrs.fields.created')} />
      <DateField source="updatedAt" label={translate('resources.emrs.fields.updated')} />
    </Datagrid>
  )
}

export default EmrDatagrid
